import { FC, useEffect } from 'react'
import { Box, Typography, Paper, Button } from '@mui/material'
import { CheckCircleOutlined } from '@ant-design/icons'
import { useAuth0 } from '@auth0/auth0-react'

const PasswordResetSuccess: FC = () => {
  const { logout } = useAuth0()

  useEffect(() => {
    // Auto-logout and redirect after 3 seconds
    const timer = setTimeout(() => {
      handleLogout()
    }, 3000)

    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin + '/',
      },
    })
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          textAlign: 'center',
        }}
      >
        <CheckCircleOutlined style={{ fontSize: 64, color: '#4caf50' }} />
        <Typography variant="h4" component="h1" gutterBottom sx={{ mt: 2 }}>
          Password Reset Successful
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Your password has been successfully changed. You will be logged out and redirected to the login page to sign
          in with your new password.
        </Typography>
        <Button variant="contained" color="primary" size="large" onClick={handleLogout} fullWidth>
          Log In Now
        </Button>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
          You will be logged out automatically in 3 seconds
        </Typography>
      </Paper>
    </Box>
  )
}

export default PasswordResetSuccess
